/**
* Generated by Kubb (https://kubb.dev/).
* Do not edit manually.
*/

import fetch from "@/api/fetchClient.js";
import type { MeControllerGetSubscriptionStatusQueryResponse, MeControllerGetSubscriptionStatus400, MeControllerGetSubscriptionStatus401, MeControllerGetSubscriptionStatus404, MeControllerGetSubscriptionStatus409, MeControllerGetSubscriptionStatus500 } from "../types/MeControllerGetSubscriptionStatus.js";
import type { Client, RequestConfig, ResponseErrorConfig } from "@/api/fetchClient.js";

function getMeControllerGetSubscriptionStatusUrl() {
  const res = { method: 'GET', url: `/api/me/subscription` as const }
  return res
}

/**
 * @description Returns the full subscription status for the current user's organisation — including trial days remaining, seat counts, Stripe customer status, and affiliate code. Use this to render in-app upsell banners.
 * @summary Get subscription status
 * {@link /api/me/subscription}
 */
export async function meControllerGetSubscriptionStatus(config: Partial<RequestConfig> & { client?: Client } = {}) {
  const { client: request = fetch, ...requestConfig } = config



  const res = await request<MeControllerGetSubscriptionStatusQueryResponse, ResponseErrorConfig<MeControllerGetSubscriptionStatus400 | MeControllerGetSubscriptionStatus401 | MeControllerGetSubscriptionStatus404 | MeControllerGetSubscriptionStatus409 | MeControllerGetSubscriptionStatus500>, unknown>({ method : "GET", url : getMeControllerGetSubscriptionStatusUrl().url.toString(), ... requestConfig })
  return res.data
}